import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpResult } from '@models/http-result';
import { ProblemDetails } from '@models/api/problem-details';
import { ValidationProblemDetails } from '@models/api/validation-problem-details';

@Injectable({
  providedIn: 'root',
})
export class ApiHandlerService {
  constructor(
    private _toastr: ToastrService,
    private _translateService: TranslateService,
    private _router: Router
  ) {}

  handleError(err: ProblemDetails | ValidationProblemDetails): HttpResult {
    if (!err.hasOwnProperty('status')) {
      this.handleAny();
    }

    switch (err.status) {
      case 404:
        return this.handle404(err);
      case 400:
        return this.handle400(err);
      case 422:
        return this.handle422(err as ValidationProblemDetails);
      case 405:
      case 505:
        return this.handleUnsupportedVersion();
      default:
        return this.handleAny();
    }
  }

  private handle404(err: ProblemDetails): HttpResult {
    return this.createHttpResult(err);
  }

  private handle422(err: ValidationProblemDetails): HttpResult {
    if (err.errors && Object.keys(err.errors).length < 1) {
      return this.createHttpResult('errorMessages.err422');
    }

    return this.createHttpResult(err);
  }

  private handle400(err: ProblemDetails): HttpResult {
    return this.createHttpResult(err);
  }

  private handleUnsupportedVersion(): HttpResult {
    return this.createHttpResult('errorMessages.version');
  }

  private handleAny(): HttpResult {
    return this.createHttpResult('errorMessages.general');
  }

  private createHttpResult(error: any): HttpResult {
    return new HttpResult(error, this._toastr, this._translateService);
  }
}
